"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewButton = exports.InputStyled = exports.Error = exports.Container = exports.AreaStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const AreaStyled = exports.AreaStyled = _styledComponents.default.textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    border: 1px solid;\n    border-color: ", ";\n    border-radius: 4px;\n    ", "\n    font-size: ", ";\n    font-weight: 400;\n    ", "\n    margin-bottom: ", ";\n    ", "\n    ", "\n    padding-right: ", ";\n    ", "\n    ", "\n\n    :focus-visible {\n        box-shadow: 0px 0px 1px 1px ", ";\n        outline: unset;\n    }\n    \n    ::placeholder {\n        font-style: italic;\n    }\n"])), _ref => {
  let {
    disabled,
    theme: {
      disabledBackground
    }
  } = _ref;
  return disabled ? "background-color: ".concat(disabledBackground, ";") : '';
}, _ref2 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryLighterColor
    }
  } = _ref2;
  return !!error ? dangerColor : primaryLighterColor;
}, (0, _Utils.parseTheme)('color', 'textColor'), (0, _Utils.getProp)('fontSize'), (0, _Utils.parseProp)('height'), _ref3 => {
  let {
    error,
    marginBottom
  } = _ref3;
  return error ? '5px' : marginBottom;
}, (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('padding'), (0, _Utils.ifProp)('isPassword', '40px', '10px'), (0, _Utils.parseProp)('textAlign', 'text-align'), (0, _Utils.parseProp)('width'), _ref4 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref4;
  return !!error ? dangerColor : primaryColor;
});
const Container = exports.Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    ", "\n    height: auto;\n    position: relative;\n    width: auto;\n"])), (0, _Utils.parseProp)('flex'));
const Error = exports.Error = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    font-size: 11px;\n    height: 10px;\n    ", "\n"])), (0, _Utils.parseTheme)('color', 'dangerColor'), (0, _Utils.parseProp)('marginBottom', 'margin-bottom'));
const InputStyled = exports.InputStyled = _styledComponents.default.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n    border: 1px solid;\n    border-color: ", ";\n    border-radius: 4px;\n    ", "\n    font-size: ", ";\n    font-weight: 400;\n    ", "\n    margin-bottom: ", ";\n    ", "\n    ", "\n    padding-right: ", ";\n    ", "\n    ", "\n\n    :focus-visible {\n        box-shadow: 0px 0px 1px 1px ", ";\n        outline: unset;\n    }\n    \n    ::placeholder {\n        font-style: italic;\n    }\n\n    ::-webkit-calendar-picker-indicator:focus {\n        box-shadow: 0px 0px 1px 1px ", ";\n        outline: unset;\n    }\n"])), _ref5 => {
  let {
    disabled,
    theme: {
      disabledBackground
    }
  } = _ref5;
  return disabled ? "background-color: ".concat(disabledBackground, ";") : '';
}, _ref6 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryLighterColor
    }
  } = _ref6;
  return !!error ? dangerColor : primaryLighterColor;
}, (0, _Utils.parseTheme)('color', 'textColor'), (0, _Utils.getProp)('fontSize'), (0, _Utils.parseProp)('height'), _ref7 => {
  let {
    error,
    marginBottom
  } = _ref7;
  return error && typeof error === 'string' ? '5px' : marginBottom;
}, _ref8 => {
  let {
    margin
  } = _ref8;
  return !!margin ? "margin: ".concat(margin, ";") : '';
}, (0, _Utils.parseProp)('padding'), (0, _Utils.ifProp)('isPassword', '40px', '10px'), (0, _Utils.parseProp)('textAlign', 'text-align'), (0, _Utils.parseProp)('width'), _ref9 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref9;
  return !!error ? dangerColor : primaryColor;
}, _ref0 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref0;
  return !!error ? dangerColor : primaryColor;
});
const ViewButton = exports.ViewButton = (0, _styledComponents.default)(_Utils.Button).withConfig({
  shouldForwardProp: prop => !['error'].includes(prop)
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    align-items: center;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    display: flex;\n    height: calc(", " - 2px);\n    justify-content: center;\n    position: absolute;\n    right: 0px;\n    top: 1px;\n    width: 40px;\n"])), _ref1 => {
  let {
    height
  } = _ref1;
  return height;
});